"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarNetShopService = void 0;
class CarNetShopService {
    constructor(loggingFacade, carNetShopClient, shopLocale, shopCountry) {
        this.loggingFacade = loggingFacade;
        this.carNetShopClient = carNetShopClient;
        this.shopLocale = shopLocale;
        this.shopCountry = shopCountry;
    }
    async hasAppArticles(vin, isWcar) {
        const articlesForApp = await this.getArticlesForCategory(vin, isWcar, 'APP');
        return articlesForApp.length > 0;
    }
    async hasFodArticles(vin, isWcar) {
        const articlesForFod = await this.getArticlesForCategory(vin, isWcar, 'FOD');
        return articlesForFod.filter(article => article.available).length > 0;
    }
    async getArticlesForCategory(vin, isWcar, category) {
        var _a, _b;
        try {
            const carNetResponse = await this.carNetShopClient.getArticleInformation(vin, isWcar, this.shopCountry, this.shopLocale);
            return (_b = (_a = carNetResponse.vehicles[0]) === null || _a === void 0 ? void 0 : _a.articles.filter((article) => article.category === category)) !== null && _b !== void 0 ? _b : [];
        }
        catch (e) {
            this.loggingFacade.error('Fetching data from CarNetShop failed', e);
            return [];
        }
    }
}
exports.CarNetShopService = CarNetShopService;
//# sourceMappingURL=CarNetShopService.js.map